import service from '@/api/request';

export type OrgInfo = {
  /** 修改时间 */
  eutime: string;
  /** 修改人 */
  modifier: string;
  /** 组织id */
  orgId: number | string;
  /** 组织名称 */
  orgName: string;
  /** 父级组织id */
  parentOrgId: string;
  /** 父级组织名称 */
  parentOrgName: string;
  prefix: string;
  stuNumReq: number;
  stuNumReqStr: string;
};
export type OrgListResponse = {
  records: Array<OrgInfo>;
  size: number;
  current: number;
  total: number;
};
type OrgListRequest = {
  current: number;
  orgId?: number;
  orgName?: string;
  parentOrgId?: string;
  prefix?: string;
  /** 1-高校 2-社会组织 */
  orgFilter?: number;
  size: number;
};
/** 获取组织列表 */
export const queryOrgByPage = (pramas: OrgListRequest) =>
  service.post<any, OrgListResponse>('/api/org/queryOrgByPage', pramas);

export type ProvinceListResponse = Array<{
  provinceId: string;
  provinceName: string;
}>;
/** 获取省份列表 */
export const getProvinceList = () => service.post<any, ProvinceListResponse>('/api/org/getProvinceList');
/** 获取城市列表 */
export type City = {
  cityShot?: string;
  name?: string;
};
export type CityListResponse = Array<{
  province?: string;
  provinceId?: string;
  city?: Array<City>;
}>;
export const getCityList = (data?: { provinceId: string | number }) =>
  service.post<any, CityListResponse>('/api/zjs/city', data);

export type CreateOrgRequest = {
  orgId?: number;
  orgName: string;
  parentOrgId: string;
  prefix: string;
  stuNumReq: number;
};
/** 创建组织 */
export const createOrg = (pramas: CreateOrgRequest) => service.post<CreateOrgRequest>('/api/org/createOrg', pramas);
/** 更新组织 */
export const updateOrg = (pramas: CreateOrgRequest) => service.post<CreateOrgRequest>('/api/org/updateOrg', pramas);
/** 获取组织详情 */
export const getOrgDetail = (pramas: { orgId: number }) =>
  service.post<CreateOrgRequest, OrgInfo>('/api/org/getOrgDetail', pramas);

export const downloadOrg = (params: any) =>
  service.post('/api/org/downloadOrg', params, {
    download: true,
  });

/** 根据组织名称获取首字母 */
export const getPrefixByOrgName = (pramas: { orgName: string }) =>
  service.post<{ orgName: string }, { prefix: string }>('/api/org/getPrefixByOrgName', pramas);

export type OrgTreeResponse = Array<{
  children: {
    id: string;
    name: string;
  }[];
  id: string;
  name: string;
  parentId: string;
}>;
/** 根据组织名称获取首字母 */
export const getOrgTree = () => service.post<any, OrgTreeResponse>('/api/selfSimulate/getOrgTree');

/** 根据组织名称获取首字母-新 */
export const getOrgTreeNew = () => service.post<any, OrgTreeResponse>('/api/org/getOrgTree');

/** getOrgGroup出参数组元素*/
type OrgGroupItem = {
  groupId: number;
  groupName: string;
  orgType: number;
  checkFlag: number;
};

/**getOrgGroup出参 */
type GetOrgGroupResponse = OrgGroupItem[];

/**getOrgGroup入参 后端要求传入'' */
type GetOrgGroupRequest = '';
/**赛事管理-赛项配置-组织分组 */
export const getOrgGroup = (args: GetOrgGroupRequest) =>
  service.post<GetOrgGroupRequest, GetOrgGroupResponse>('/api/org/getOrgGroup', args);
